import RequestClass from "./RequestClass";
import React from "react";
import { BASKET_TYPE_CHOICES, BASKET_UNKNOWN } from "../components/Enumerators";
import { RefCallBack } from "react-hook-form";
// import { log } from "../components/elements/Debug";

export default class CartClass extends React.Component {
    // --------------
    // ustawianie id koszyka
    // --------------
    public static set_basketId(basketType: BASKET_TYPE_CHOICES, basketId?: string) {
        // log("USTAWIAM NA " + basketId);
        if (basketId) {
            if (basketType === BASKET_TYPE_CHOICES.BASKET_ORDER) sessionStorage.setItem("order_basket_id", basketId);
            else sessionStorage.setItem("inquiry_basket_id", basketId);
        }
    }
    public static del_basketId(basketType: BASKET_TYPE_CHOICES) {
        // log("USTAWIAM NA " + basketId);

        if (basketType === BASKET_TYPE_CHOICES.BASKET_ORDER) sessionStorage.setItem("order_basket_id", BASKET_UNKNOWN);
        else sessionStorage.setItem("inquiry_basket_id", BASKET_UNKNOWN);
    }

    // --------------
    // sprawdzenie i pobranie z pamięcie aktualnego basketId
    // --------------
    public static get_basketId(basketType: BASKET_TYPE_CHOICES) {
        var basketId: string | null | undefined;
        if (basketType === BASKET_TYPE_CHOICES.BASKET_ORDER) {
            basketId = sessionStorage.getItem("order_basket_id");
        } else {
            basketId = sessionStorage.getItem("inquiry_basket_id");
        }
        if (basketId === null || basketId === undefined) {
            basketId = BASKET_UNKNOWN;
        }

        return basketId;
    }

    // --------------
    // sprawdzenie i pobranie tyu koszyka na podstawie jego ID
    // --------------
    public static get_basketType(basketId: string | undefined) {
        if (basketId === undefined) return BASKET_TYPE_CHOICES.BASKET_UNDEFINED;
        if (sessionStorage.getItem("order_basket_id") === basketId) {
            return BASKET_TYPE_CHOICES.BASKET_ORDER;
        } else if (sessionStorage.getItem("inquiry_basket_id") === basketId) {
            return BASKET_TYPE_CHOICES.BASKET_INQUIRY;
        }
        return BASKET_TYPE_CHOICES.BASKET_UNDEFINED;
    }

    // --------------
    // aktualzacja pozycji w koszyku
    // --------------
    public static put(
        productId: number,
        quantity: number,
        basketType: BASKET_TYPE_CHOICES,
        custom_success_callback: RefCallBack,
        custom_error_callback: RefCallBack
    ) {
        //sprawdź czy mamy już koszyk
        let basketId = this.get_basketId(basketType);

        var reqOptions = {
            method: "PUT",
            body: JSON.stringify({
                basketId: basketId,
                productId: productId,
                type: basketType,
                cnt: quantity,
            }),
        };

        RequestClass.makeRequest("basket/", reqOptions, custom_success_callback, custom_error_callback);
    }

    // --------------
    // pobieranie koszyka
    // --------------
    public static get(
        basketType: BASKET_TYPE_CHOICES,
        success_callback: RefCallBack,
        error_callback: RefCallBack
        // offerBasketId?: string // wtedy kiedy basketType == BASKET_OFFER
    ) {
        //console.log("aa")
        let basketId = this.get_basketId(basketType);
        // basketType == BASKET_TYPE_CHOICES.BASKET_OFFER
        //     ? offerBasketId
        //     : this.get_basketId(basketType);
        if (basketId === "" || basketId === BASKET_UNKNOWN || basketId === undefined) {
            /* nie ma informacji o numerze koszyka - nie robię zapytania */
            //console.log("Koszyk jest pusty")
            success_callback(null);
            return;
        }

        var reqOptions = {
            method: "GET",
        };

        function succ_callback_custom(result: any) {
            CartClass.set_basketId(basketType, result.basketId);
            success_callback(result);
        }

        RequestClass.makeRequest("basket/" + basketId + "/", reqOptions, succ_callback_custom, error_callback);
    }

    // --------------
    // dodawanie produktu do koszyka
    // --------------
    public static add(
        productId: number,
        quantity: number,
        basketType: BASKET_TYPE_CHOICES,
        custom_success_callback: RefCallBack,
        custom_error_callback: RefCallBack
    ) {
        //sprawdź czy mamy już koszyk
        let basketId = this.get_basketId(basketType);

        var reqOptions = {
            method: "POST",
            body: JSON.stringify({
                basketId: basketId,
                productId: productId,
                type: basketType,
                cnt: quantity,
            }),
        };

        const success_callback = (result: any) => {
            CartClass.set_basketId(basketType, result.basketId);
            // if (basketType===BASKET_TYPE_CHOICES.BASKET_ORDER)
            //     sessionStorage.setItem('order_basket_id', result.basketId);
            // else
            //     sessionStorage.setItem('inquiry_basket_id', result.basketId);

            custom_success_callback(result);
        };

        const error_callback = (result: any) => {
            custom_error_callback(result);
        };

        //let req = new RequestClass()
        //req.send(requestUrl, reqOptions, null, "", null);
        RequestClass.makeRequest("basket/", reqOptions, success_callback, error_callback);
    }
}
